import React from 'react';
import { GenericRadio } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isRequired } from '../../../utils/validation';

const ApplicableToAccounts = ({ values }) => (
  <Content>
    {({
      businessMandateApplicableToAccountsLabel,
      businessMandateApplicableToAccountsValue1,
      businessMandateApplicableToAccountsValue2,
      businessMandateApplicableToAccountsYesValue,
      businessMandateApplicableToAccountsNoValue,

      globalRadioError
    }) => (
      <Field
        name="future_accounts"
        subscription={{ touched: true, error: true }}
        validate={isRequired}
      >
        {({ meta: { touched, error }, input }) => (
          <GenericFieldWrapper
            inputId="future_accounts"
            title={businessMandateApplicableToAccountsLabel}
            validationMessage={touched && !!error ? globalRadioError : ''}
          >
            <GenericRadio.StackedSet
              groupName="future_accounts"
              items={[
                {
                  id: businessMandateApplicableToAccountsNoValue,
                  labelText: businessMandateApplicableToAccountsValue1
                },
                {
                  id: businessMandateApplicableToAccountsYesValue,
                  labelText: businessMandateApplicableToAccountsValue2
                }
              ]}
              selectedId={values.future_accounts}
              {...input}
              onChange={selectedId => {
                if (
                  selectedId === businessMandateApplicableToAccountsValue1 &&
                  values &&
                  values.no_signatories_to_sign
                )
                  delete values.no_signatories_to_sign;
                input.onChange(selectedId);
              }}
            />
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default ApplicableToAccounts;
